import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import styled, { css } from 'styled-components';
import { pxToRem, getSpacing, getLength, getPropFilter } from 'utils/ui';
import { overflowWrap } from 'styles/mixins';
import { DEFAULT_LEFT_CELL_PADDING } from '../utils';
import { withTableContext, TABLE_CONTEXT_PROP_NAMES } from './TableContext';
function getBreakpoint(key) {
  return function (p) {
    return p.theme.globals.breakpoints[p[key]];
  };
}
export var tableCellPropFilter = getPropFilter([].concat(_toConsumableArray(TABLE_CONTEXT_PROP_NAMES), ['hideBelowBreakpoint', 'width', 'isCheckbox']));
export var tableCellBaseStyles = css(["position:relative;font-weight:inherit;text-align:left;width:", ";height:", ";padding:", " ", ";padding-right:0;", " &:focus{outline:none;}&.focus-visible{outline:3px solid ", ";outline-offset:-1px;}@media (min-width:", "){", " ", "}", ""], function (p) {
  return p.width ? getLength(p.width) : 'auto';
}, function (p) {
  return pxToRem(p.rowMinHeight || 0);
}, function (p) {
  return p.theme.globals.spacing.xxs;
}, function (p) {
  return p.theme.globals.spacing[DEFAULT_LEFT_CELL_PADDING];
}, overflowWrap, function (p) {
  return p.theme.links;
}, getBreakpoint('mobileViewBreakpoint'), function (p) {
  return p.pl && css(["&:first-child{padding-left:", ";}"], getSpacing(p.pl, p.theme));
}, function (p) {
  return p.pr && css(["&:last-child{padding-right:", ";}"], getSpacing(p.pr, p.theme));
}, function (p) {
  return p.hideBelowBreakpoint && css(["@media (max-width:", "){display:none;}"], getBreakpoint('hideBelowBreakpoint'));
});
var TableCell = styled.td.withConfig({
  shouldForwardProp: tableCellPropFilter
}).withConfig({
  displayName: "TableCell",
  componentId: "sc-1ghunzu-0"
})(["", " @media (max-width:", "){display:flex;height:auto;font-weight:bold;", "}"], tableCellBaseStyles, getBreakpoint('mobileViewBreakpoint'), function (p) {
  return p.isCheckbox ? css(["position:absolute;top:0;left:0;bottom:auto;height:", ";z-index:", ";"], pxToRem(p.rowMinHeight || 0), function (p) {
    return p.theme.globals.z.flat;
  }) : css(["&::before{content:attr(data-columnheader) ': ';margin-right:", ";font-weight:normal;white-space:nowrap;}"], function (p) {
    return p.theme.globals.spacing.xs;
  });
});
export default withTableContext(TableCell);